<style scoped lang="scss">
.assistance-toggle-label {
  font-size: 1.4em;
  display: flex;

  .checkbox-container {
    width: 30px;
  }

  span {
    /*margin-left: 8px;*/

  }

  input[type=checkbox] {
    transform: scale(1.4);
  }
}
</style>
<template>
  <div v-if="application" class="uk-form">
    <div id="app-wizard-step-2" class="uk-grid">
      <div class="uk-width-1-1 uk-margin-large-top" v-if="programSettings['uses-duplicative-assistance']">
        <fieldset class="uk-margin-large-bottom">
          <legend class="uk-h3">{{ duplicatedAssistanceStatement }}</legend>
          <input id="radio-duplicated-services-yes" type="radio" class="uk-radio" :value="1"
                 v-model="application.receiving_other_assistance">
          <label for="radio-duplicated-services-yes"> {{ __('global.yes') }}</label>
          <br/>
          <input id="radio-duplicated-services-no" type="radio" class="uk-radio" :value="0"
                 v-model="application.receiving_other_assistance">
          <label for="radio-duplicated-services-no"> {{ __('global.no') }}</label>
        </fieldset>
      </div>


      <div
          v-if="application.renter && application.program.rent_program && (application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false)"
          class="uk-width-1-1 uk-margin-large-bottom">
        <div class="uk-width-1-1">
          <h2>{{ __('tenant.rental_information') }}</h2>
          <label class="assistance-toggle-label">
            <div class="checkbox-container">
              <input type="checkbox" v-model="application.renter" class="uk-checkbox" :disabled="true"
                     :aria-label="`${__('tenant.rental_information')} ${__('tenant.i_am_a_renter')}`">
              <label v-if="isLandlordLocked"><i class="uk-icon-question"
                                                uk-tooltip="You can't change Landloard when application has payments on batches."></i></label>
            </div>
            <div>
              <span>{{ __('tenant.i_am_a_renter') }}</span>
            </div>
          </label>
        </div>

        <div v-if="application.renter && application.program.rent_program" class="uk-width-1-1 uk-margin-top">
          <div class="uk-grid">
            <div class="uk-width-small-1-1 uk-width-medium-2-3" style="margin-left: 25px; padding-right: 25px;">
              <validated-section :errors="errors" field="renterManager">
                <property-contact-form
                    v-show="permissions.processor || renterManager.company_name || programSettings['tenant-can-create-organizations']"
                    table="household_applications"
                    :isLocked="isLandlordLocked"
                    :application-role-id="3"
                    @beforeSubmit="save"
                    :allowChange="allowPropertyContactChange && (permissions.processor || programSettings['tenant-can-create-organizations'])"
                    :person="renterManager"></property-contact-form>
                <tenant-landlord-form
                    v-if="!programSettings['tenant-can-create-organizations']"
                    ref="landlordForm"></tenant-landlord-form>
              </validated-section>
              <hr class="uk-width-1-1 uk-margin-top uk-margin-bottom">
              <label for="related_to_landlord"> <input type="checkbox" v-model="application.related_to_landlord"
                                                       :disabled="isLandlordLocked"> {{
                  __('tenant.check_this_box')
                }}</label>
              <hr class="uk-width-1-1 uk-margin-top uk-margin-bottom">
            </div>
          </div>
        </div>
      </div>

      <template
          v-if="application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false">
        <div class="uk-width-1-1 uk-margin-large-bottom" v-for="type in assets.unitLedgerEntryTypes" :key="type.id">
          <ledger-entries-for-type
              @updated="updateLedgerValues(type, $event)"
              :ref="'assistance_'+type.id"
              :show-disconnect="type.is_utility"
              :form-errors="errors"
              v-if="type.is_utility || (application.renter && type.key == 'rent') || (application.home_owner && type.key == 'mortgage')"
              :type="type">

            <!-- Home Owner Fields -->
            <div
                v-if="type.key === 'mortgage' || type.key === 'mortgage_reinstatement' || type.key === 'mortgage_payments'">

              <fieldset data-uk-margin>
                <legend>The Property Has (check all that apply)</legend>
                <div class="uk-grid uk-margin-bottom">
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <validated-section :errors="errors" field="owner_liens">
                      <label>
                        <input type="checkbox" v-model="owner.liens.first"/>
                        {{ __('tenant.first_lien') }}
                      </label>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <label>
                      <input type="checkbox" v-model="owner.liens.second"/>
                      {{ __('tenant.second_lien') }}
                    </label>
                  </div>
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <label>
                      <input type="checkbox" v-model="owner.liens.additional"/>
                      {{ __('tenant.additional_lien') }}
                    </label>
                  </div>
                </div>
                <hr class="uk-grid-divider">

                <legend>My property taxes and insurance</legend>
                <div class="uk-grid uk-margin-bottom">
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <validated-section :errors="errors" field="escrowed">
                      <label><input type="radio" v-model="owner.escrowed" :value="0" class="">
                        {{ __('tenant.my_property_tax_1') }}</label>
                    </validated-section>

                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label><input type="radio" v-model="owner.escrowed" :value="1"
                                  onClick="UIkit.modal.alert(__('tenant.my_property_tax_2_alert'));">
                      {{ __('tenant.my_property_tax_2') }}</label>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label><input type="radio" v-model="owner.escrowed" :value="2"
                                  onClick="UIkit.modal.alert(__('tenant.my_property_tax_3_alert'))">
                      {{ __('tenant.my_property_tax_3') }}</label>
                  </div>
                  <div class="uk-width-medium-1-4 uk-margin-bottom">
                    <label><input type="radio" v-model="owner.escrowed" :value="3"
                                  onClick="UIkit.modal.alert(__('tenant.my_property_tax_4_alert'))">
                      {{ __('tenant.my_property_tax_4') }}</label>
                  </div>

                </div>
                <hr class="uk-grid-divider">

                <legend>{{ __('tenant.have_homeonwers_association') }}</legend>
                <div class="uk-grid uk-margin-bottom">
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <validated-section :errors="errors" field="hoa">
                      <label><input type="radio" v-model="owner.hoa" :value="0">
                        {{ __('tenant.have_homeonwers_association_1') }}</label>
                    </validated-section>
                  </div>
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <label><input type="radio" v-model="owner.hoa" :value="1">
                      {{ __('tenant.have_homeonwers_association_2') }}</label>
                  </div>
                  <div class="uk-width-medium-1-3 uk-margin-bottom">
                    <label><input type="radio" v-model="owner.hoa" :value="2"
                                  onClick="UIkit.modal.alert(__('tenant.have_homeonwers_association_3_alert'));">
                      {{ __('tenant.have_homeonwers_association_3') }}</label>
                  </div>


                </div>
                  <hr class="uk-grid-divider uk-margin-bottom uk-margin-top app-fades" style="border:none;">
              </fieldset>
            </div>

            <div class="uk-width-1-1" v-if="type.key === 'rent'">


              <div class="uk-grid">

                <div class="uk-width-1-1 uk-width-medium-1-1" v-if="programSettings['uses-bedroom-count-field']">
                  <label class="">{{ __('tenant.how_many_bedrooms') }}</label><br/>
                  <validated-section :errors="errors" field="bedroom_count">
                    <select aria-label="How Many Bedrooms Do You Have?" v-model="application.bedroom_count"
                            class="uk-select uk-width-1-1 uk-form-large" style="width: 100%;" :disabled="type.isLocked">
                      <option :value="null"></option>
                      <option :value="0">{{ __('tenant.efficiency') }}</option>
                      <option :value="1">{{ __('tenant.one_br') }}</option>
                      <option :value="2">{{ __('tenant.two_br') }}</option>
                      <option :value="3">{{ __('tenant.three_br') }}</option>
                      <option :value="4">{{ __('tenant.four_br') }}</option>
                    </select>
                  </validated-section>
                </div>

                <div class="uk-width-1-1 uk-width-medium-1-1" v-if="programSettings['uses-bedroom-count-field']">
                  <label class="">{{ __('tenant.how_much_rent') }}</label><br/>
                  <validated-section :errors="errors" field="rent_amount">
                    <input type="number" v-model="application.rent_amount" class="uk-form-large uk-width-1-1"
                           :disabled="type.isLocked">
                  </validated-section>
                </div>

                <div class="uk-width-1-1 uk-margin-bottom" v-if="permissions.processor && application.fmr_amount">
                  <h3> {{ __('tenant.fmr_amount') }}: {{ application.fmr_amount | formatMoney }}</h3>
                </div>

                <div class="uk-width-1-1 uk-width-medium-1-1" v-if="application.program.agency_short_name == 'MHFA'">
                  <label>{{ __('tenant.my_eviction_status') }}:</label><br/>
                  <validated-section :errors="errors" field="applicant_eviction_status_id">
                    <select :aria-label="__('tenant.my_eviction_status')"
                            v-model="application.applicant_eviction_status_id" class="uk-select uk-form-large"
                            style="width: 100%;" :disabled="type.isLocked">
                      <option :value="0"></option>
                      <option :value="1">I am behind but have not received an eviction or lease termination notice</option>
                      <option :value="2">I have received a notice of eviction or lease termination</option>
                      <option :value="3">I have received a notice of nonrenewal of my lease</option>
                      <option :value="4">I have received an eviction summons (notice to appear in court)</option>
                      <option :value="5">I went to housing court and lost an eviction action</option>
                      <option :value="6">I have been served with a writ of recovery</option>
                      <option :value="7" v-if="programSettings['uses-vacated-status']">I have moved out of this property
                        and am seeking assistance with rent debts.
                      </option>
                    </select>
                  </validated-section>
                </div>

                <div class="uk-width-1-1 uk-width-medium-1-1" v-else>
                  <label>{{ __('tenant.my_eviction_status') }}:</label><br/>
                  <validated-section :errors="errors" field="applicant_eviction_status_id">
                    <select :aria-label="__('tenant.my_eviction_status')"
                            v-model="application.applicant_eviction_status_id" class="uk-select uk-form-large"
                            style="width: 100%;" :disabled="type.isLocked">
                      <option :value="0"></option>
                      <option :value="1">{{ __('tenant.3_day_notice') }}</option>
                      <option :value="2">{{ __('tenant.court_date_notice') }}</option>
                      <option :value="3">{{ __('tenant.am_not_delinquent') }}</option>
                      <option :value="4">{{ __('tenant.am_deliquent') }}</option>
                      <option :value="5">{{ __('tenant.been_evicted') }}</option>
                    </select>
                  </validated-section>
                </div>

              </div>
              <div class="uk-grid" v-if="programSettings['uses-federal-subsidy-questions']">
                <div class="uk-width-small-1-1 uk-width-medium-1-1" style="padding-bottom: 15px;">
                  <label>{{ __('tenant.federal_subsidy') }}</label>
                  <div class="uk-grid uk-margin-top">
                    <div class="uk-width-1-4">
                      <label>
                        <input type="radio" :value="1" v-model="received_ami_subsidy"> {{ __('global.yes') }}
                      </label>
                    </div>
                    <div class="uk-width-1-4">
                      <label>
                        <input type="radio" :value="0" v-model="received_ami_subsidy"> {{ __('global.no') }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="uk-width-small-1-1 uk-width-medium-1-1" v-if="received_ami_subsidy">
                  <label>{{ __('tenant.rent_adjusted') }} </label>
                  <div class="uk-grid uk-margin-top">
                    <div class="uk-width-1-4">
                      <label>
                        <input type="radio" :value="1" v-model="ami_subsidy_adjusted" :disabled="type.isLocked">
                        {{ __('global.yes') }}
                      </label>
                    </div>
                    <div class="uk-width-1-4">
                      <label>
                        <input type="radio" :value="0" v-model="ami_subsidy_adjusted"
                               onClick="UIkit.modal.alert('You will need to speak with your property manager and have them adjust your rents based on your current income prior to requesting rental assistance. You can move forward with requesting utility and/or internet assistance.  However, please note that once the utility/internet assistance is received, you must wait 90 days to apply for more assistance (including rental assistance). To avoid this delay, you may want to wait until your rent adjustment has been made so you can apply for all assistance at the same time. Be sure to get a copy from your Manager that shows what your rents have been adjusted to and when the new rents take effect.');"
                               :disabled="type.isLocked"> {{ __('global.no') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="received_ami_subsidy" class="uk-grid">
                <div class="uk-width-1-1 uk-width-medium-1-2" v-if="ami_subsidy_adjusted == 1">
                  <label class="">{{ __('tenant.which_federal_program') }}</label><br/>
                  <validated-section :errors="errors" field="federal_program_assistance_id">
                    <select aria-label="Which federal program gives you the assistance?"
                            v-model="application.federal_program_assistance_id" class="uk-select uk-form-large"
                            style="width: 100%;" :disabled="type.isLocked">
                      <option :value="0"></option>
                      <option :value="1">{{ __('tenant.section_8_project') }}</option>
                      <option :value="2">{{ __('tenant.section_8_housing') }}</option>
                      <option :value="3">{{ __('tenant.hud_project') }}</option>
                      <option :value="4">{{ __('tenant.usda_rural') }}</option>
                      <option :value="5">{{ __('tenant.other') }}</option>
                    </select>
                  </validated-section>
                </div>

                <div class="uk-width-1-1 uk-width-medium-1-2"
                     v-if="application.federal_program_assistance_id == 5 && ami_subsidy_adjusted == 1">
                  <validated-section :errors="errors" field="federal_program_assistance_other">
                    <label>{{ __('tenant.name_fedral_program') }}</label>
                    <input type="text" placeholder="Federal Program Name"
                           v-model="application.federal_program_assistance_other"
                           class="uk-width-1-1 uk-margin-bottom uk-form-large" :disabled="type.isLocked">
                  </validated-section>
                </div>

                <div class="uk-width-small-1-1 uk-margin-top uk-alert-danger" style="padding: 8px;"
                     v-if="ami_subsidy_adjusted === 0 && programSettings['ami-blocks-rent-entries']">
                  {{ __('tenant.warning_ami_adjusted') }}
                </div>
              </div>
              <div class="uk-grid"
                   v-if="received_ami_subsidy == 1 && ami_subsidy_adjusted == 1 && programSettings['requires-interim-certification']">
                <div class="uk-width-small-1-1 uk-width-medium-2-3">
                  <FileUploadDropzone
                      uploadUrl="api/hope/documents"
                      title="Interim Certification, or Document showing Rent Adjustment to Current Income"
                      :documents="uploads"
                      :member="applicant"
                      fileType="assistance-rent"
                      @fileAdded="fileAdded"
                      @fileDeleted="fileDeleted"
                      ref="dropzoneUpload"
                  ></FileUploadDropzone>
                  <validated-section :errors="errors" field="renterDocs">
                  </validated-section>
                </div>
              </div>
            </div>

          </ledger-entries-for-type>
        </div>
      </template>
    </div>

    <div
        v-if="application.receiving_other_assistance !== null || programSettings['hide-assistance-without-funding-response'] === false"
        class="uk-margin-large-top uk-text-right">
      <validated-section field="total_requested" :errors="errors">
        <h2 class="uk-text-right" tabindex="0">{{ __('tenant.total_assistance_requested') }}:
          {{ totalRequested | formatMoney }}</h2>
        <div
            v-if="programSettings['maximum-amount-per-application'] && totalRequested > programSettings['maximum-amount-per-application']"
            class="uk-text-danger">
          Your requested amount exceeds the maximum of
          {{ programSettings['maximum-amount-per-application'] | formatMoney }} for this program.
        </div>
      </validated-section>
      <h2 v-if="permissions.processor" class="uk-text-right" tabindex="0">{{ __('tenant.total_assistance_approved') }}:
        {{ totalApproved | formatMoney }}</h2>
      <h2 v-if="permissions.processor" class="uk-text-right" tabindex="0">{{ __('tenant.total_assistance_paid') }}:
        {{ totalPaid | formatMoney }}</h2>
      <h3 class="uk-text-right" tabindex="0">Months Selected: {{ monthsSelected }}</h3>
      <h3 class="uk-text-right" tabindex="0">Months with Requested Amounts: {{ monthsWithRequested }}</h3>
      <h3 class="uk-text-right" tabindex="0">Months with Approved Amounts: {{ monthsWithApproved }}</h3>
      <h3 class="uk-text-right" tabindex="0">Months with Paid Amounts: {{ monthsWithPayment }}</h3>
      <h3 class="uk-text-right" tabindex="0">Total Months Selected (including reapplies): {{ totalMonthsSelected }}</h3>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
// import moment from 'moment';
import ValidatedSection from "../../../../../components/Common/ValidatedSection";
import PropertyContactForm from "../../../../../components/AppWizard/Step2/PropertyContactForm";
import LedgerEntriesForType from "../../../../../components/AppWizard/Step2/LedgerEntriesForType";
import FileUploadDropzone from "../../../../../../components/FileUploadDropzone";
import TenantLandlordForm from "../../../../../components/AppWizard/Step2/TenantLandlordForm";

export default {
  name: "Step2",
  components: {TenantLandlordForm, LedgerEntriesForType, PropertyContactForm, ValidatedSection, FileUploadDropzone},
  data() {
    return {
      errors: {},
      uploads: [],
      eviction: false,
      evictionDeposit: 0,
      evictionRent: 0,
      evictionNewName: '',
      evictionContactPhone: '',
      evictionContactEmail: '',
      totalRequested: 0,
      totalApproved: 0,
      totalPaid: 0,
      monthsSelected: 0,
      monthsWithRequested: 0,
      monthsWithPayment: 0,
      monthsWithApproved: 0,
      totalMonthsSelected: 0,

      owner: {
        liens: {
          first: false,
          second: false,
          additional: false,
        },
        escrowed: null,
        hoa: null,
        mortgageServiceProvider: '',
        mortgageAccountNumber: '',
        mortgageCurrent: true,
        unpaidPrincipalAmount: 0,
        delinquentAmount: 0,
      },
      allowPropertyContactChange: true
    }
  },
  computed: {
    hasMortgageType() {
      let hasAssistance = false;
      _.each(this.assets.unitLedgerEntryTypes, type => {
        if (['mortgage', 'mortgage_reinstatement', 'mortgage_payments'].includes(type.key) && this.$refs['assistance_' + type.id]) {
          let component = this.$refs['assistance_' + type.id][0];
          if (component && component.needsAssistance) {
            hasAssistance = true;
          }
        }
      })
      return hasAssistance;
    },

    rent() {
      for (var i in this.assets.unitLedgerEntryTypes) {
        let type = this.assets.unitLedgerEntryTypes[i];
        if (this.application.renter && type.key == 'rent' && this.$refs['assistance_' + type.id]) {
          let component = this.$refs['assistance_' + type.id][0];
          return component
        }
      }
      return null;
    },
    needRentAssistance() {
      for (var i in this.assets.unitLedgerEntryTypes) {
        let type = this.assets.unitLedgerEntryTypes[i];
        if (this.application.renter && type.key == 'rent' && this.$refs['assistance_' + type.id]) {
          let component = this.$refs['assistance_' + type.id][0];
          return component.needsAssistance;
        }
      }
      return false;
    },
    isLandlordLocked() {
      let result = false;
      _.each(this.assets.unitLedgerEntryTypes, item => {
        if (item.isLocked) {
          result = true;
        }
      });
      return result;
    },
    duplicatedAssistanceStatement() {
      if (this.programSettings && this.programSettings['duplicative-assistance-statement']) {
        return this.programSettings['duplicative-assistance-statement'];
      } else {
        return 'Have you received assistance through any other programs?';
      }
    },
    received_ami_subsidy: {
      get() {
        return this.application.received_ami_subsidy;
      },
      set(value) {
        this.$store.commit('Application/setApplicationField', {field: 'received_ami_subsidy', value: value})
        if (value == 0) {
          this.$store.commit('Application/setApplicationField', {field: 'ami_subsidy_adjusted', value: null})
        }
      },
    },
    ami_subsidy_adjusted: {
      get() {
        return this.received_ami_subsidy ? this.application.ami_subsidy_adjusted: null;
      },
      set(value) {
        this.$store.commit('Application/setApplicationField', {field: 'ami_subsidy_adjusted', value: value})
      },
    },
    unitLedgerEntryTypes() {
      if (this.application.receiving_other_assistance !== null || this.programSettings['hide-assistance-without-funding-response'] === false) {
        return this.assets.unitLedgerEntryTypes;
      }
      return [];
    },
    ...mapState('App', {
      usingScreenReader: state => state.usingScreenReader,
      permissions: state => state.permissions,
    }),
    ...mapState('Application', {
      assets: state => state.assets,
      application: state => state.application,
      documents: state => state.documents,
      applicant: state => state.applicant,
      renterOwner: state => state.renterOwner,
      renterManager: state => state.renterManager,
      organization: state => state.organization,
      household: state => state.household,
    }),
    ...mapGetters('Application', ['programSettings']),
  },
  watch: {
    application(newValue) {
      this.initData();
    },
    received_ami_subsidy(newValue) {
      this.getTotalRequested();
    },
    ami_subsidy_adjusted(newValue) {
      if (newValue === 0 && this.programSettings['ami-blocks-rent-entries']) {
        // Remove rental assistance records
        this.$refs.assistance_1[0].clearAssistance();
      } else {
        this.$refs.assistance_1[0].setDataFromEntries();
        this.$refs.assistance_1[0].needsAssistance = true;
      }
      this.totalRequested = this.getTotalRequested();
    },
    'owner.liens.second': function (newValue) {
      if (newValue == true && this.hasMortgageType) {
        UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
      }
    },
    'owner.liens.additional': function (newValue) {
      if (newValue == true && this.hasMortgageType) {
        UIkit.modal.alert('Attention! Please be aware that our current programs will only provide assistance for your primary loan.');
      }
    },

  },
  mounted() {
    if (this.application) {
      this.initData();
    }

    if (this.application.receiving_other_assistance == null)
    {
      this.application.receiving_other_assistance = 0;
    }
    this.updateLedgerValues();
  },
  methods: {
    fileAdded(docs) {
      this.uploads = this.uploads.concat(docs)
    },

    fileDeleted(index) {
      this.uploads.splice(index, 1)
    },

    updateLedgerValues(type, payload) {
      if (payload) {
        this.allowPropertyContactChange = !Object.values(payload).find(item => item.has_payment);
      } else {
        this.allowPropertyContactChange = true
      }

      this.totalRequested = this.getTotalRequested();
      this.totalApproved = this.getTotalApproved();
      this.totalPaid = this.getTotalPaid();
      ;
      this.monthsWithPayment = this.getMonthsWithPayment();

      this.monthsSelected = this.getMonthsSelected();
      this.monthsWithRequested = this.getMonthsWithRequested();
      this.monthsWithPayment = this.getMonthsWithPayment();
      this.monthsWithApproved = this.getMonthsWithApproved();
      this.totalMonthsSelected = this.getTotalMonthsSelected();
      this.$forceUpdate();
    },


    initData() {
      this.owner.liens.first = this.application.has_first_lien == 1;
      this.owner.liens.second = this.application.has_second_lien == 1;
      this.owner.liens.additional = this.application.has_additional_lien == 1;
      this.owner.mortgageCurrent = this.application.mortgage_current == 1;
      this.owner.unpaidPrincipalAmount = this.application.mortgage_unpaid_principal_amount === null ? 0 : parseFloat(this.application.mortgage_unpaid_principal_amount);
      this.owner.delinquentAmount = this.application.mortgage_delinquent_amount === null ? 0 : parseFloat(this.application.mortgage_delinquent_amount);
      this.owner.escrowed = this.application.escrow_value;
      this.owner.hoa = this.application.hoa_value;
      this.owner.mortgageServiceProvider = this.application.mortgage_servicer ? this.application.mortgage_servicer : '';
      this.owner.mortgageAccountNumber = this.application.mortgage_account_number ? this.application.mortgage_account_number : '';
      this.mortgageAmount = parseFloat(this.application.requested_mortgage_amount);

      this.eviction = this.application.is_eviction == 1;
      this.evictionDeposit = this.application.eviction_deposit ? this.application.eviction_deposit : 0;
      this.evictionRent = this.application.eviction_rent ? this.application.eviction_rent : 0;
      this.evictionNewName = this.application.eviction_name ? this.application.eviction_name : '';
      this.evictionContactPhone = this.application.eviction_phone ? this.application.eviction_phone : '';
      this.evictionContactEmail = this.application.eviction_email ? this.application.eviction_email : '';

      this.totalRequested = this.getTotalRequested();

      this.uploads = this.documents.filter(item => item.file_type === 'assistance-rent')
    },

    isSequential(array) {
      let length = array.length;
      if (length === 1) return true;
      let first = array.shift();
      let last = array.pop();
      let diff = last.diff(first, 'months');
      return diff === length - 1;
    },
    validateConsecutive(values, maxConsecutive) {
      let months = [];
      _.each(values, (amounts, key) => {
        if (amounts.due > 0 || amounts.fees > 0 || amounts.paid > 0) {
          months.push(moment(key + '-15'));
        }
      })

      if (!months.length)
        return true;

      if (months.length > maxConsecutive) {
        return false;
      }

      // make sure months are consecutive
      let sequential = this.isSequential(months);

      if (!sequential) return false;

      return true;
    },
    hasMortgageAssistance() {
      let hasAssistance = false;
      _.each(this.assets.unitLedgerEntryTypes, type => {
        if (type.key.includes('mortgage') && this.$refs['assistance_' + type.id]) {
          let component = this.$refs['assistance_' + type.id][0];
          if (component && component.needsAssistance) {
            hasAssistance = true;
          }
        }
      })
      return hasAssistance;
    },
    async save() {
      let data = {};

      if (this.$refs.landlordForm && !this.programSettings['tenant-can-create-organizations']) {
        data['landlord_form'] = this.$refs.landlordForm.getForm();
      }

      if (this.application.home_owner) {
        let mortgageAmount = (this.owner.mortgageCurrent) ? this.owner.unpaidPrincipalAmount : this.owner.delinquentAmount;

        data['has_first_lien'] = this.owner.liens.first;
        data['has_second_lien'] = this.owner.liens.second;
        data['has_additional_lien'] = this.owner.liens.additional;
        // data['mortgage_current'] = this.owner.mortgageCurrent;
        // data['mortgage_unpaid_principal_amount'] = this.owner.unpaidPrincipalAmount;
        // data['mortgage_delinquent_amount'] = this.owner.delinquentAmount;
        data['escrow_value'] = this.owner.escrowed;
        data['hoa_value'] = this.owner.hoa;
        data['mortgage_servicer'] = this.application.mortgage_servicer;
        data['mortgage_account_number'] = this.owner.mortgageAccountNumber;
        data['requested_mortgage_amount'] = mortgageAmount;
        data['service_name'] = this.application.service_name;
      }
      if (this.application.renter) {
        data['manager_company_name'] = this.application.manager_company_name;
        data['owner_company_name'] = this.application.owner_company_name;
        data['documents'] = this.uploads;

      }

      data['received_ami_subsidy'] = this.application.received_ami_subsidy;
      data['ami_subsidy_adjusted'] = this.application.ami_subsidy_adjusted;
      data['applicant_disconnect_status_id'] = this.application.applicant_disconnect_status_id;
      data['applicant_eviction_status_id'] = this.application.applicant_eviction_status_id;
      data['federal_program_assistance_id'] = this.application.federal_program_assistance_id;
      data['federal_program_assistance_other'] = this.application.federal_program_assistance_other;
      data['bedroom_count'] = this.application.bedroom_count;
      data['rent_amount'] = this.application.rent_amount;
      data['related_to_landlord'] = this.application.related_to_landlord;

      let ule = [];
      _.each(this.assets.unitLedgerEntryTypes, type => {
        if (type.is_utility || (this.application.renter && type.key == 'rent') || (this.application.home_owner && type.key == 'mortgage')) {
          let component = this.$refs['assistance_' + type.id][0];
          if (component.needsAssistance) {
            let inputs = component.getMonthInputs();
            _.each(inputs, (amounts, monthString) => {
              let dueDate = monthString;
              if (amounts.own_ule) {
                ule.push({
                  unit_ledger_entry_type_id: type.id,
                  due_date: moment(dueDate + '-01').format('YYYY-MM-DD'),
                  amount_due: amounts.amount,
                  fees_due: amounts.fees,
                  amount_paid: amounts.paid,
                  application_id: this.application.id,
                  household_member_id: component.getHouseholdMemberId(),
                  disconnect_status_id: component.getDisconnectStatusId(),
                  alternative_funding_programs: amounts.alternative_funding_programs,
                  account_number: component.getAccountNumber(),
                  vendor_organization_id: component.getVendorId(),
                  vendor_organization_name: component.getVendorName(),
                  amount_approved: amounts.approved,
                  paid_by_sponsor: amounts.paid_by_sponsor,
                  has_payment: amounts.has_payment ? 1 : 0,
                })
              }
            })
          }
        }
      });
      data['unit_ledger_entries'] = ule;
      data['receiving_other_assistance'] = this.application.receiving_other_assistance;

      return axios.put(`/api/hope/applications/${this.application.id}/step-2`, data)
    },
    async validateStep() {
      this.errors = {};

      if (this.application.home_owner && this.application.program.rent_program) {

        if (this.hasMortgageAssistance())
        {
          if (this.owner.liens.first === false && this.owner.liens.first === false && this.owner.liens.first === false) {
            this.errors['owner_liens'] = {errors: ['You must select at least one lien option.']};
          }

          if (this.owner.escrowed === null) {
            this.errors['escrowed'] = {errors: ['You must make a taxes and insurance selection.']}
          }

          if (this.owner.hoa === null) {
            this.errors['hoa'] = {errors: ['You must make a HOA selection.']}
          }

          // if(this.owner.mortgageCurrent === true && (this.owner.unpaidPrincipalAmount === 0 || this.owner.unpaidPrincipalAmount === null)) {
          //     this.errors['unpaidPrincipalAmount'] = { errors: ['You must enter an amount.']}
          // }
          //
          // if(this.owner.mortgageCurrent === false && (this.owner.delinquentAmount === 0 || this.owner.delinquentAmount === null)) {
          //     this.errors['delinquentAmount'] = { errors: ['You must enter an amount.']}
          // }

          // if(this.owner.mortgageAccountNumber === null || this.owner.mortgageAccountNumber === '') {
          //     this.errors['mortgageAccountNumber'] = { errors: ['Mortgage Account Number is required.']}
          // }
          //
          // if(this.application.mortgage_servicer === null || this.application.mortgage_servicer === '') {
          //     this.errors['mortgageServiceProvider'] = { errors: ['Mortgage Servicer Name is required.']}
          // }
        }
      }

      if (this.application.renter && this.application.program.rent_program) {
        // Needs property owner and manager


        if (this.programSettings['tenant-can-create-organizations']) {
          if (!this.renterManager || !this.renterManager.company_name) {
            this.errors.renterManager = {errors: ['You must have a property manager selected.']}
          }
        }

        if (this.needRentAssistance) {
          if (this.programSettings['uses-federal-subsidy-questions']) {
            if (this.received_ami_subsidy === null) {
              this.errors.received_ami_subsidy = {errors: ['You must select an answer to this question.']}
            }

            if (this.received_ami_subsidy) {
              if (this.ami_subsidy_adjusted === null) {
                this.errors.ami_subsidy_adjusted = {errors: ['You must select an answer to this question.']}
              }

              if (this.ami_subsidy_adjusted == 1 && this.application.federal_program_assistance_id === null || this.application.federal_program_assistance_id === 0) {
                this.errors.federal_program_assistance_id = {errors: ['You must select an answer to this question.']}
              }

              if (this.application.federal_program_assistance_id == 5 && this.ami_subsidy_adjusted == 1 && !this.application.federal_program_assistance_other) {
                this.errors.federal_program_assistance_other = {errors: ['You must select an answer to this question.']}
              }

              if (this.received_ami_subsidy == 1 && this.ami_subsidy_adjusted == 1 && this.programSettings['requires-interim-certification']) {
                if (this.uploads.length == 0) {
                  this.errors.renterDocs = {errors: ['You must upload document(s) showing your Interim Certificate or Rent Adjustment.']}
                }
              }
            }
          }

          if (!this.application.applicant_eviction_status_id) {
            this.errors['applicant_eviction_status_id'] = {errors: ['This field is required.']};
          }

          if (this.application.bedroom_count == null && this.programSettings['uses-bedroom-count-field']) {
            this.errors['bedroom_count'] = {errors: ['This field is required.']};
          }

          if (this.application.program.consecutive_month_constraint !== null && this.application.program.consecutive_month_constraint !== 0) {
            if (this.rent && !this.validateConsecutive(this.rent.monthInputs, this.application.program.consecutive_month_constraint)) {
              this.errors['rent_months'] = {errors: ['You can only select up to ' + this.application.program.consecutive_month_constraint + ' consecutive months.']};
            }
          }
        }

        if (this.uploads.length === 0 && this.received_ami_subsidy == 1 && this.ami_subsidy_adjusted == 1 && this.programSettings['requires-interim-certificate']) {
          this.errors.renterDocs = {errors: ['You must provide renter document.']}
        }
      }

      for (var i in this.assets.unitLedgerEntryTypes) {
        let type = this.assets.unitLedgerEntryTypes[i];

        if (type.is_utility || (this.application.renter && type.key == 'rent') || (this.application.home_owner && type.key == 'mortgage')) {
          let component = this.$refs['assistance_' + type.id][0];
          let errors = await component.validate();
          if(type.key === 'mortgage') {
            console.log('DOING THIS', this.application.home_owner, JSON.parse(JSON.stringify(errors)));
          }
          if (_.size(errors)) {
            this.errors = _.merge(this.errors, errors);
          }
        }

      }

      if (this.totalRequested === 0) {
        this.$set(this.errors, 'total_requested', ['You must request assistance in at least one section above to continue.']);
      }

      if (this.programSettings['maximum-amount-per-application'] && this.totalRequested > this.programSettings['maximum-amount-per-application']) {
        this.$set(this.errors, 'total_requested_amount', ['Your requested amount exceeds the maximum amount allowed for this program.']);
      }

      console.log('Assistance Step Error Log: ', this.errors)

      if (_.size(this.errors) > 0) return false;

      // Validate LL Form
      if (this.$refs.landlordForm && !this.programSettings['tenant-can-create-organizations']) {
        if (!this.renterManager || !this.renterManager.company_name) {
          this.errors = await this.$refs.landlordForm.validate();
          if (_.size(this.errors) > 0) return false;
        }
      }

      // Server Validation

      try {
        let r = await this.save();
        this.$store.dispatch('Application/fetch', this.application.id);
        this.$store.dispatch('Application/fetchVendorList', this.application.id)
        // Success
        return true;
      } catch (err) {
        this.errors = err.response.data.errors;
        return false;
      }
    },


    getTotalRequested() {
      let total = 0;

      _.each(this.assets.unitLedgerEntryTypes, type => {
        let component = this.$refs['assistance_' + type.id];

        if (!type.is_utility) {
          // Check AMI
          if (this.received_ami_subsidy && this.ami_subsidy_adjusted === 0) {
            return;
          }
        }

        if (component) {
          if (component[0] && component[0].needsAssistance) {
            let inputs = component[0].getMonthInputs();
            _.each(inputs, (amounts, monthString) => {
              if (amounts.own_ule) {
                let monthDue = amounts.amount + amounts.fees - amounts.paid;

                if (amounts.alternative_funding_programs && amounts.alternative_funding_programs.length) {
                  _.each(amounts.alternative_funding_programs, afp => {
                    monthDue -= afp.pivot.amount;
                  })
                }

                total += monthDue;
              }
            })
          }
        }

      });

      return total;
    }
    ,

    getTotalApproved() {
      let total = 0;

      _.each(this.assets.unitLedgerEntryTypes, type => {
        let component = this.$refs['assistance_' + type.id];

        if (!type.is_utility) {
          // Check AMI
          if (this.received_ami_subsidy && this.ami_subsidy_adjusted === 0) {
            return;
          }
        }

        if (component) {
          if (component[0] && component[0].needsAssistance) {
            let inputs = component[0].getMonthInputs();
            _.each(inputs, (amounts, monthString) => {
              if (amounts.own_ule && amounts.approved) {
                let monthDue = amounts.approved;
                total += monthDue;
              }

            })
          }
        }

      });

      return total;
    }
    ,
    getTotalPaid() {
      let total = 0;

      _.each(this.assets.unitLedgerEntryTypes, type => {
        let component = this.$refs['assistance_' + type.id];

        if (!type.is_utility) {
          // Check AMI
          if (this.received_ami_subsidy && this.ami_subsidy_adjusted === 0) {
            return;
          }
        }

        if (component) {
          if (component[0] && component[0].needsAssistance) {
            let inputs = component[0].getMonthInputs();
            _.each(inputs, (amounts, monthString) => {
              if (amounts.own_ule) {
                let monthDue = parseFloat(amounts.paid_by_sponsor);
                // Check if monthDue is NaN
                if (isNaN(monthDue)) {
                  monthDue = 0;
                }

                total += monthDue;
              }
            })
          }
        }

      });

      return total;
    }
    ,

    getMonthsWithFilter(filter) {
      let months = [];
      _.each(this.assets.unitLedgerEntryTypes, type => {
        if (this.$refs['assistance_' + type.id]) {
          let component = this.$refs['assistance_' + type.id][0];
          _.each(component.monthInputs, (values, monthString) => {
            if (filter(values)) {
              months.push(monthString);
            }

          })
        }
      })
      return _.size(_.uniq(months));
    }
    ,

    getMonthsSelected() {
      return this.getMonthsWithFilter(values => values.own_ule);
    }
    ,
    getMonthsWithRequested() {
      return this.getMonthsWithFilter(values => values.own_ule && (values.amount > 0 || values.paid > 0 || values.fees));
    }
    ,

    getMonthsWithPayment() {
      return this.getMonthsWithFilter(values => values.own_ule && values.paid_by_sponsor > 0);
    }
    ,

    getMonthsWithApproved() {
      return this.getMonthsWithFilter(values => values.own_ule && values.approved > 0);
    }
    ,

    getTotalMonthsSelected() {
      return this.getMonthsWithFilter(values => true);
    },

    validate() {
      return true;
    }
    ,

    onCurrentMortgageChanged($event) {
      if ($event.checked) {
        this.owner.delinquentAmount = 0;
      }
    }
    ,
  }
}
</script>
